import Swiper from 'swiper';
import './style.css';
class PCProductGrid extends HTMLElement {
  constructor() {
    super();
    this.initSwiper = this.initSwiper.bind(this);
  }

  connectedCallback() {
    this.initSwiper();
  }

  initSwiper() {
    const swiperContainer = this.querySelector('.pc-product-grid__carousel');
    if (swiperContainer) {
      new Swiper(swiperContainer, {
        slidesPerView: 2,
        spaceBetween: 25,
        breakpoints: {
          769: {
            slidesPerView: 3,
          },
        },
      });
    }
  }
}

customElements.define('pc-product-grid', PCProductGrid); 